import React from "react";
import { useCurrency } from "../context/CurrencyContext";

/**
 * Compact currency selector for the site header.
 */
function CurrencySwitcher({ className = "", compact = false }) {
  const { currency, setCurrency, supportedCurrencies, isDetecting } = useCurrency();

  return (
    <label
      className={`inline-flex items-center gap-1.5 text-sm font-semibold text-gray-700 ${className}`}
    >
      <span className="sr-only">Currency</span>
      {!compact && (
        <span className="hidden lg:inline text-xs font-medium text-gray-500 uppercase tracking-wide">
          {isDetecting ? "…" : "Currency"}
        </span>
      )}
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className="appearance-none rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-800 shadow-sm hover:border-emerald-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 cursor-pointer"
        aria-label="Select currency"
      >
        {supportedCurrencies.map((code) => (
          <option key={code} value={code}>
            {code}
          </option>
        ))}
      </select>
    </label>
  );
}

export default CurrencySwitcher;
